<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <path d="M10.25 5.5C10.25 8.12335 8.12335 10.25 5.5 10.25C2.87665 10.25 0.75 8.12335 0.75 5.5C0.75 2.87665 2.87665 0.75 5.5 0.75C8.12335 0.75 10.25 2.87665 10.25 5.5Z" stroke-width="1.5" stroke="var(--Shades-00)"/>
    <path d="M15.25 5.5C15.25 8.12335 13.1234 10.25 10.5 10.25C7.87665 10.25 5.75 8.12335 5.75 5.5C5.75 2.87665 7.87665 0.75 10.5 0.75C13.1234 0.75 15.25 2.87665 15.25 5.5Z" stroke-width="1.5" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconClinicInfo'
}
</script>
